<svelte:options
  customElement={{
    tag: "cta-biz",
    shadow: "none"
  }}
/>

<script>
  import "./Button.svelte";
  const cta = "/assets_default/images/business/common/cta_m.webp"
  const cta_s = "/assets_default/images/business/common/cta_s.webp"
  let {
    size = 'large',
    url_open = '/business/open-account/notes/',
    url_login = '未定（共通）',
    click_id_open = "pc-footer-business",
    click_id_login = "pc-footer-business",
    title_open = "法人口座を開設する",
    title_login = "ログインして再開する",
    blank_open = false,
    blank_login = true
  } = $props();
</script>

<div class="show:pc">
  {#if size === "small"}
  <div class="owd-biz-cta owd-biz-cta:small">
    <div class="owd-biz-cta-wrap">
      <div class="owd-biz-cta-textarea">
        <p class="owd-biz-cta-title align:center owd-heading:03 spacing:bottom:24">口座開設は<br>オンラインで最短翌営業日</p>
        <div class="spacing:bottom:16">
          <button-biz class="owd-biz-cta-button" url={url_open} id={click_id_open} title={title_open}></button-biz>
        </div>
        <p class="owd-text:02 align:center"><a href="{url_login}" id="{click_id_login}" target="{blank_login}" class="owd-textlink"><strong>ログインして再開する</strong></a></p>
      </div>
      <div class="owd-biz-cta-imagearea">
        <img src="{cta_s}" alt="">
      </div>
    </div>
  </div>
  {:else}
  <div class="owd-biz-cta owd-biz-cta:large">
    <div class="owd-biz-cta-wrap">
      <div class="owd-biz-cta-textarea">
        <p class="owd-biz-cta-title align:center owd-heading:06">口座開設は<br>オンラインで最短翌営業日</p>
        <div class="owd-biz-cta-button-wrap">
          <button-biz url={url_open} id={click_id_open} title={title_open} target={blank_open}></button-biz>
          <button-biz url={url_login} id={click_id_login} title={title_login} type="secondary:white" target={blank_login}></button-biz>
        </div>
      </div>
      <div class="owd-biz-cta-imagearea">
        <img src="{cta}" alt="">
      </div>
    </div>
  </div>
  {/if}
</div>

<style lang="scss">


.owd-biz-cta{
  background-color: var(--accent);
  &-wrap{
    width: 100%;
    display: grid;
    align-items: center;
  }
  @include g.mobile () {
    &-wrap{
      padding: 32px 24px!important;
      gap: 24px;
      grid-template-columns: 1fr!important;
    }
    &-textarea{
      display: contents;
    }
    &-button-wrap{
      order: 2;
    }
    &-imagearea{
      order: 1;
      margin: 0 auto;
    }
  }
  &\:large{
    padding: 120px 0;
    .owd-biz-cta{
      &-wrap{
        gap: clamp(10px,calc((54px/1200px) * 100%), 54px);
        grid-template-columns: 1fr calc((542px/1200px)*100%);
        width: 95%;
        max-width: 1200px;
        margin: 0 auto;
      }
      &-button-wrap{
        display: grid;
        gap: 16px;
        grid-template-columns: 1fr 1fr;
        .owd-button{
          max-width: none;
        }
      }
      &-title{
        margin-bottom: 48px;
      }
    }
    @include g.mobile () {
      .owd-biz-cta{
        &-wrap{
          padding: 32px 24px;
          gap: 12px;
          grid-template-columns: 1fr;
        }
        &-title{
          margin-bottom: 12px;
          @include g.owd-typography($fz: 'heading-2', $line-height-px: 40, $letter-spacing-tracking: 25, $font-weight: 600);
          padding: 2.5px 0;
        }
        &-imagearea{
          max-width: 294px;
          margin-bottom: 12px;
        }
      }
    }
  }
  &\:small{
    max-width: 790px;
    min-height: 218px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    :global(.owd-button){
      margin: 0 auto;
    }
    .owd-biz-cta{
      &-wrap{
        padding: 0 80px;
        grid-template-columns: 1fr calc((276.902px/790px)*100%);
      }
    }
    @include g.mobile () {
      .owd-biz-cta{
        &-title{
          margin-bottom: 0;
        }
        &-imagearea{
          max-width: 194px;
        }
      }
    }
  }
}
</style>
